document.addEventListener('DOMContentLoaded', () => {
    const isSafari15 = !!navigator.userAgent.match(/15[.eE]\d+ Safari/i);
    const SMOOTH_SCROLL = isSafari15 ? 'instant' : 'smooth';
    const timelineSidebar = document.querySelector('.TimelineGrid-sidebar');
    const timelineGrid = document.querySelector('.TimelineGrid');
    const timelineSidebarInner = timelineSidebar.querySelector('.TimelineGrid-sidebarInner');
    const mainNav = document.querySelector('.HeaderNavigationBar');
    const slides = document.querySelectorAll('.TimelineGrid-contentsYear');
    const timelineSections = [];

    slides.forEach((elem, index) => {
            const year = elem.getAttribute("data-year");
            const tabElem = document.querySelector(`.TimelineGrid-sidebarYear[data-year="${year}"]`);
            const isFirst = index === 0;
            const isLast = index === slides.length - 1;

            tabElem.addEventListener(
                'click',
                (e) => {
                    window.scrollTo({
                        top: window.scrollY + elem.getBoundingClientRect().top - mainNav.getBoundingClientRect().bottom - 16,
                        behavior: SMOOTH_SCROLL
                    });
                }
            );

            timelineSections.push({
                year,
                elem,
                tabElem,
                isFirst,
                isLast,
                sync: () => {
                    const midpoint = window.innerHeight / 2;
                    const rect = elem.getBoundingClientRect();

                    let isActive = rect.top < midpoint && rect.bottom > midpoint;
                    if (isFirst) isActive = rect.bottom > midpoint;
                    else if (isLast) isActive = rect.top < midpoint;

                    tabElem.classList.toggle('is-active', isActive)
                }
            });
        }
    );

    function timelineSync() {
        timelineSections.forEach((section) => section.sync());
    }
    window.addEventListener("scroll", timelineSync);

    timelineSync();

    const selectElement = document.getElementById("year-selector");

    selectElement.addEventListener("change", function () {

        const selectedYear = this.value;
        const targetSection = document.querySelector(`.TimelineGrid-contentsYear[data-year="${selectedYear}"]`);
        if (targetSection) {
            const navHeight = document.querySelector(".TimelineGrid-select").offsetHeight; // Adjust for sticky nav
            const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY - navHeight - mainNav.getBoundingClientRect().bottom;
            setTimeout(() => {
                window.scrollTo({
                    top: targetPosition,
                    behavior: SMOOTH_SCROLL
                });
            }, 100);
        }
    });
});
